var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOctoUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59326 24.5124V16.8901C5.59326 14.3258 6.95703 11.9552 9.17235 10.6651L16.3754 6.47293C18.6147 5.16999 21.3822 5.16999 23.6216 6.47293L30.8246 10.6651C33.0415 11.9552 34.4053 14.3258 34.4053 16.8901V24.5124C34.4053 27.0767 33.0415 29.4473 30.8262 30.7374L23.6232 34.9296C21.3838 36.2325 18.6163 36.2325 16.377 34.9296L9.17395 30.7374C6.95703 29.4473 5.59326 27.0767 5.59326 24.5124Z",
    stroke: "#395DFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 14.2985C21.9636 14.2985 23.5562 15.8911 23.5562 17.8551C23.5562 19.8192 21.9636 21.4118 19.9996 21.4118C18.0355 21.4118 16.4429 19.8192 16.4429 17.8551C16.4429 15.8911 18.0355 14.2985 19.9996 14.2985",
    stroke: "#395DFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4025 27.1039C26.2168 26.6349 25.9271 26.2155 25.5573 25.873V25.873C24.9315 25.2935 24.1151 24.9702 23.262 24.9702C21.839 24.9702 18.1623 24.9702 16.7393 24.9702C15.8861 24.9702 15.0682 25.2935 14.4423 25.873V25.873C14.0726 26.2139 13.7844 26.6349 13.5972 27.1039",
    stroke: "#395DFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctoUser);
export default __webpack_public_path__ + "static/media/octo-user.711d4649e0f6f19311fb9be3e53bba4e.svg";
export { ForwardRef as ReactComponent };